import type { MiddlewareAPI } from 'redux';
import { combineEpics, type ActionsObservable } from 'redux-observable';
import type { State } from '../../state/reducers/types';
import initializeFieldsEpic from './initialize-fields';

// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
export default (action$: ActionsObservable<any>, store: MiddlewareAPI<State>) =>
	combineEpics(initializeFieldsEpic())(action$, store);
